import { createStyles, Theme } from "@material-ui/core";

export const styles = (theme: Theme) => createStyles({
    container: {
        flexGrow: 1,
        position: "relative"
    },
    suggestionsContainerOpen: {
        position: "absolute",
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: "block",
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: "none",
    },
});


// WEBPACK FOOTER //
// ./src/components/InputCustomerAutocomplete/InputCustomerAutocomplete.style.tsx